<mat-form-field #formField appearance="outline" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input
    [autocomplete]="autocomplete"
    #nativeElement
    matInput
    [formControl]="control"
    [placeholder]="placeholder"
    [mask]="mask"
    [patterns]="customPatterns"
    [maxLength]="maxLength"
    (blur)="onBlurEvent()"
    [errorStateMatcher]="matcher"
  />
  <mat-icon *ngIf="error()" matSuffix class="mat-error">error</mat-icon>
  <mat-icon *ngIf="matPrefixIcon" matPrefix>{{ matPrefixIcon }}</mat-icon>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()">{{ error() }}</mat-error>
</mat-form-field>
